import React from "react";
import PropTypes from "prop-types";
import { Card } from "uikit/components";
import styles from "./SchoolSummaryCard.module.styl";
import SchoolSummaryApiClient from "api/SchoolSummaryApiClient";
import { BuildReportFileTrigger } from "components/index";
import { ReportFormat } from "api/Enums";

export default function SchoolSummaryCard({ schoolId }) {
    return (
        <Card borderRadius={"giant"} padding={"none"} className={styles.form} name="school_summary">
            <div>
                <div className={styles.descriptionText}>
                    Посмотрите показатели цифровизации вашей организации
                </div>

                <BuildReportFileTrigger
                    startBuildingReportFunc={() =>
                        SchoolSummaryApiClient.buildSchoolSummary(schoolId, ReportFormat.Excel)
                    }
                    formatIcon="Excel"
                    triggerText="Скачать подробный отчет"
                    downloadText="Скачать Excel-отчет"
                />
            </div>
        </Card>
    );
}

SchoolSummaryCard.propTypes = {
    schoolId: PropTypes.number.isRequired,
};
